var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ml-3",attrs:{"color":_vm.color,"text-color":_vm.textColor}},[(_vm.icon)?_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1):_vm._e(),_vm._v("\n    "+_vm._s(_vm.orderStatusName)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }